import React from 'react';
import { Link } from 'react-router-dom';

const FixedButtons: React.FC = () => {
  return (
    <div className="fixed-buttons">
      <Link to="/become-member/" className="fixed-btn member-btn">
        <i className="fas fa-user-plus"></i>
        <span className="btn-text">Become A Member</span>
      </Link>
      <Link to="/volunteer/" className="fixed-btn volunteer-btn">
        <i className="fas fa-hands-helping"></i>
        <span className="btn-text">Volunteer</span>
      </Link>
      <Link to="/donate/" className="fixed-btn donate-btn">
        <i className="fas fa-donate"></i>
        <span className="btn-text">Donate Us</span>
      </Link>
    </div>
  );
};

export default FixedButtons;